(() => {
  const testId = 'MC_CART_ORDERCLARITY_ENGRAVINGJEWELRY';
  const selector = `[maison-ab-id="${testId}"]`;
  const chainId = 9635999777023;
  const giftId = 9640746057983;
  const cart = document.querySelector('cart-notification.open_drawer');
  const root = cart?.querySelector(selector);
  const formRoot = cart?.querySelector('#minicart-form');
  const editor = cart?.querySelector('.maison-cart-editor');
  if (!root || !formRoot || !editor) return;

  const params = new URLSearchParams(location.search);
  if (root.dataset.maisonReviewTheme === 'true' && params.get('maison_ab_preview') === testId) {
    const arm = params.get('maison_ab_arm');
    if (arm === 'control' || arm === 'variation') root.dataset.maisonAbArm = arm;
  }

  const form = editor.querySelector('form');
  let draft = null;
  let previousFocus = null;
  let saving = false;
  const route = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);

  function showError(message) {
    const error = form.querySelector('.maison-cart-editor__error');
    error.textContent = message;
    error.hidden = !message;
  }
  function positionRemoveControls() {
    if (root.dataset.maisonAbArm !== 'variation') return;
    formRoot.querySelectorAll('.maison-cart-chain').forEach(card => {
      const priceLine = card.querySelector('.maison-cart-price-line');
      const remove = card.querySelector('.minicart__bottom .minicart__item-remove');
      if (priceLine && remove) priceLine.append(remove);
    });
  }
  function makeField(labelText, type, value, values) {
    const label = document.createElement('label');
    label.className = 'maison-cart-editor__field';
    label.append(document.createTextNode(labelText));
    const control = document.createElement(type === 'select' ? 'select' : 'input');
    if (type === 'select') {
      values.forEach(entry => {
        const option = document.createElement('option');
        option.value = entry;
        option.textContent = entry;
        control.append(option);
      });
    } else {
      control.type = 'text';
      control.maxLength = 9;
      control.required = true;
      control.autocomplete = 'off';
    }
    control.value = value || '';
    label.append(control);
    form.append(label);
    return control;
  }
  function selectedVariant() {
    return draft.product.variants.find(variant => variant.available &&
      variant.options[0] === draft.finish.value && variant.options[1] === draft.count.value);
  }
  function updateDraft() {
    const count = draft.countValues.indexOf(draft.count.value) + 1;
    draft.names.forEach((field, index) => {
      field.parentElement.hidden = index >= count;
      field.disabled = index >= count;
    });
    const variant = selectedVariant();
    draft.price.textContent = variant ? `Updated item price: ${money(variant.price * draft.item.quantity)}` : 'This option combination is unavailable.';
    form.querySelector('button[type="submit"]').disabled = !variant || saving;
    showError('');
  }
  function renderForm() {
    form.replaceChildren();
    const product = draft.product;
    const finishes = [...new Set(product.variants.map(variant => variant.options[0]))];
    draft.finish = makeField(product.options[0] || 'Finish', 'select', draft.item.options_with_values?.[0]?.value || draft.item.variant_options?.[0], finishes);
    draft.countValues = [...new Set(product.variants.map(variant => variant.options[1]))];
    draft.count = makeField(product.options[1] || 'Number of pendants', 'select', draft.item.options_with_values?.[1]?.value || draft.item.variant_options?.[1], draft.countValues);
    draft.names = draft.countValues.map((_, index) => makeField(`Name ${index + 1}`, 'text', draft.item.properties?.[`${index + 1}. name`] || ''));
    draft.font = makeField('Font', 'select', draft.item.properties?.Font || 'Gothic', ['Gothic', 'Centuary']);
    const note = document.createElement('p');
    note.className = 'maison-cart-editor__note';
    note.textContent = draft.gift ? 'Changes apply to this necklace. The included bracelet keeps the matching finish.' : 'Changes apply to this necklace.';
    form.append(note);
    draft.price = document.createElement('p');
    draft.price.className = 'maison-cart-editor__price';
    form.append(draft.price);
    const error = document.createElement('p');
    error.className = 'maison-cart-editor__error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    form.append(error);
    const actions = document.createElement('div');
    actions.className = 'maison-cart-editor__actions';
    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.textContent = 'Cancel';
    cancel.addEventListener('click', event => {
      event.stopPropagation();
      close();
    });
    const save = document.createElement('button');
    save.type = 'submit';
    save.textContent = 'Save changes';
    actions.append(cancel, save);
    form.append(actions);
    draft.finish.addEventListener('change', updateDraft);
    draft.count.addEventListener('change', updateDraft);
    updateDraft();
  }
  async function getCart() {
    const response = await fetch(`${route}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load your cart. Please try again.');
    return response.json();
  }
  async function syncDrawerCount() {
    if (root.dataset.maisonAbArm !== 'variation') return;
    try {
      const current = await getCart();
      const count = cart.querySelector('.cart-count-drawer');
      if (count) count.textContent = ` (${current.item_count}) `;
    } catch (_) { /* The next cart refresh will retry. */ }
  }
  let upsellOverlay = null;
  function closeUpsell() {
    if (!upsellOverlay) return;
    const trigger = upsellOverlay.trigger;
    upsellOverlay.remove();
    upsellOverlay = null;
    trigger?.focus();
  }
  async function openUpsellConfigurator(button, productUrl, page) {
    closeUpsell();
    const productResponse = await fetch(`${productUrl.pathname}.js`, { headers: { Accept: 'application/json' } });
    if (!productResponse.ok) throw new Error('Could not load the product options. Please try again.');
    const product = await productResponse.json();
    const panel = document.createElement('div');
    panel.className = 'maison-cart-upsell-config';
    panel.innerHTML = '<div class="maison-cart-upsell-config__backdrop" data-maison-upsell-close></div><section class="maison-cart-upsell-config__panel" role="dialog" aria-modal="true" aria-labelledby="maison-upsell-title"><header><h2 id="maison-upsell-title"></h2><button type="button" data-maison-upsell-close aria-label="Close product options">×</button></header><form class="maison-cart-upsell-config__form"><div class="maison-cart-upsell-config__options"></div><div class="maison-cart-upsell-config__fields"></div><p class="maison-cart-upsell-config__price" aria-live="polite"></p><p class="maison-cart-upsell-config__status" role="alert" hidden></p><button class="maison-cart-upsell-config__submit" type="submit">Add to Cart</button></form></section>';
    panel.trigger = button;
    panel.querySelector('h2').textContent = `Add ${product.title}`;
    root.append(panel);
    upsellOverlay = panel;
    updateViewport();
    panel.querySelector('[data-maison-upsell-close][aria-label]').focus();
    const form = panel.querySelector('form');
    const optionsNode = form.querySelector('.maison-cart-upsell-config__options');
    const fieldsNode = form.querySelector('.maison-cart-upsell-config__fields');
    const priceNode = form.querySelector('.maison-cart-upsell-config__price');
    const status = form.querySelector('[role="alert"]');
    const submit = form.querySelector('button[type="submit"]');
    const initial = product.variants.find(variant => variant.id === Number(button.dataset.variantId) && variant.available) || product.variants.find(variant => variant.available);
    if (!initial) { closeUpsell(); throw new Error('This product is unavailable.'); }
    const selects = [];
    product.options.forEach((option, index) => {
      const name = typeof option === 'string' ? option : option.name;
      if (name === 'Title' && product.variants.length === 1) return;
      const label = document.createElement('label');
      label.className = 'maison-cart-upsell-config__field';
      label.append(document.createTextNode(name));
      const select = document.createElement('select');
      const values = [...new Set(product.variants.map(variant => variant.options[index]))];
      values.forEach(value => select.add(new Option(value, value)));
      select.value = initial.options[index];
      label.append(select);
      optionsNode.append(label);
      selects[index] = select;
    });
    const selectedVariant = () => product.variants.find(variant => variant.options.every((value, index) => !selects[index] || selects[index].value === value));
    const templates = [...page.querySelectorAll('.main-product-section fieldset[class*="variant-field-"]')];
    function renderFields() {
      const previous = Object.fromEntries([...new FormData(form)].filter(([name]) => name.startsWith('properties[')));
      fieldsNode.replaceChildren();
      const variant = selectedVariant();
      priceNode.textContent = variant ? money(variant.price) : 'Unavailable combination';
      submit.disabled = !variant?.available;
      if (!variant) return;
      const chosen = product.options.map((_, index) => [...new Set(product.variants.map(entry => entry.options[index]))].indexOf(variant.options[index]));
      const selected = templates.filter(fieldset => {
        const match = fieldset.className.match(/variant-field-(\d+)-(\d+)-\d+/);
        return match && (Number(match[1]) === 0 || chosen[Number(match[1]) - 1] === Number(match[2]));
      });
      selected.forEach(fieldset => {
        const source = fieldset.querySelector('[name^="properties["]');
        if (!source) return;
        const label = document.createElement('label');
        label.className = 'maison-cart-upsell-config__field';
        label.append(document.createTextNode(fieldset.querySelector('.form__label, legend')?.textContent.trim() || source.name.slice(11, -1)));
        let control;
        if (source.type === 'radio' || source.tagName === 'SELECT') {
          control = document.createElement('select');
          const choices = source.type === 'radio' ? [...fieldset.querySelectorAll(`[name="${source.name}"]`)].map(input => input.value) : [...source.options].map(option => option.value);
          choices.forEach(value => control.add(new Option(value, value)));
          control.value = previous[source.name] || (source.type === 'radio' ? fieldset.querySelector(`[name="${source.name}"]:checked`)?.value : source.value) || choices[0];
        } else {
          control = document.createElement(source.tagName === 'TEXTAREA' ? 'textarea' : 'input');
          if (control.tagName === 'INPUT') control.type = source.type || 'text';
          control.value = previous[source.name] || source.value || '';
          if (source.maxLength > 0) control.maxLength = source.maxLength;
          if (source.minLength > 0) control.minLength = source.minLength;
          if (source.pattern) control.pattern = source.pattern;
          if (source.dataset.shouldCapitalize === 'true') control.addEventListener('input', () => { control.value = control.value.toUpperCase(); });
        }
        control.name = source.name;
        control.required = source.required;
        label.append(control);
        fieldsNode.append(label);
      });
    }
    optionsNode.addEventListener('change', renderFields);
    renderFields();
    let submitting = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting || !form.reportValidity()) return;
      const variant = selectedVariant();
      if (!variant?.available) return;
      const properties = {};
      new FormData(form).forEach((value, name) => { if (name.startsWith('properties[')) properties[name.slice(11, -1)] = String(value).trim(); });
      if (Object.values(properties).some(value => /\p{Extended_Pictographic}/u.test(value))) {
        status.textContent = 'Please remove emojis from the personalization.';
        status.hidden = false;
        return;
      }
      submitting = true;
      submit.disabled = true;
      submit.textContent = 'Adding…';
      status.hidden = true;
      try {
        const result = await mutate('add', { items: [{ id: variant.id, quantity: 1, properties }], sections: ['minicart-form'], sections_url: location.pathname });
        await refreshDrawer(result);
        closeUpsell();
      } catch (error) {
        status.textContent = error.message || 'Could not add this item. Please try again.';
        status.hidden = false;
      } finally {
        submitting = false;
        submit.disabled = !selectedVariant()?.available;
        submit.textContent = 'Add to Cart';
      }
    });
  }
  async function startUpsell(button) {
    if (root.dataset.maisonAbArm !== 'variation' || button.disabled) return;
    const productUrl = new URL(button.dataset.productUrl, location.origin);
    if (productUrl.origin !== location.origin || !productUrl.pathname.includes('/products/')) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading…';
    try {
      const response = await fetch(productUrl.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Could not load this product. Please try again.');
      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const needsPersonalization = !!page.querySelector('.main-product-section [name^="properties["]');
      if (needsPersonalization) {
        if (page.querySelector('legacy-product') || !page.querySelector('.main-product-section fieldset[class*="variant-field-"]')) {
          // Keep any product-specific bundle flow on its original form.
          if (root.dataset.maisonReviewTheme === 'true') {
            productUrl.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
            productUrl.searchParams.set('maison_ab_preview', testId);
            productUrl.searchParams.set('maison_ab_arm', 'variation');
          }
          location.assign(productUrl.toString());
          return;
        }
        await openUpsellConfigurator(button, productUrl, page);
        return;
      }
      const variantId = Number(button.dataset.variantId);
      if (!variantId) throw new Error('Could not identify this product. Please try again.');
      const result = await mutate('add', { items: [{ id: variantId, quantity: 1 }], sections: ['minicart-form'], sections_url: location.pathname });
      await refreshDrawer(result);
    } catch (error) {
      button.textContent = error.message || 'Could not open this product. Try again.';
      setTimeout(() => { button.textContent = originalLabel; }, 4500);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (button.textContent === 'Loading…') button.textContent = originalLabel;
    }
  }
  async function open(button) {
    if (saving || root.dataset.maisonAbArm !== 'variation') return;
    previousFocus = button;
    try {
      const state = await getCart();
      const item = state.items.find(line => line.key === button.dataset.key && line.product_id === chainId);
      if (!item) throw new Error('This cart item has changed. Please reopen the drawer and try again.');
      const card = button.closest('.cart-item');
      const product = JSON.parse(card.querySelector('[data-maison-cart-product]').textContent);
      const giftNode = card.querySelector('[data-maison-gift-variant]');
      const gift = giftNode ? { product: JSON.parse(giftNode.querySelector('[data-maison-gift-product]').textContent), quantity: item.quantity } : null;
      draft = { item, product, gift };
      renderForm();
      editor.hidden = false;
      editor.querySelector('.maison-cart-editor__panel').scrollTop = 0;
      updateViewport();
      draft.names.find(input => !input.disabled)?.focus();
    } catch (error) {
      draft = null;
      const original = button.textContent;
      button.textContent = error.message;
      setTimeout(() => { button.textContent = original; }, 4500);
    }
  }
  function close() {
    if (saving) return;
    editor.hidden = true;
    form.replaceChildren();
    draft = null;
    editor.style.bottom = '';
    previousFocus?.focus();
  }
  function updateViewport() {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const keyboardInset = Math.max(0, innerHeight - viewport.height - viewport.offsetTop);
    const previewBar = root.dataset.maisonReviewTheme === 'true' ? document.querySelector('#PBarNextFrame') : null;
    const previewInset = previewBar ? 64 : 0;
    const bottom = `${Math.max(keyboardInset, previewInset)}px`;
    if (upsellOverlay) {
      upsellOverlay.style.bottom = bottom;
      upsellOverlay.style.setProperty('--maison-visual-height', `${viewport.height}px`);
    }
    if (!editor.hidden) {
      editor.style.bottom = bottom;
      editor.style.setProperty('--maison-visual-height', `${viewport.height}px`);
    }
  }
  function sameProperties(first, second) {
    const entries = object => Object.entries(object || {}).filter(([, value]) => value !== '' && value != null).sort(([a], [b]) => a.localeCompare(b));
    return JSON.stringify(entries(first)) === JSON.stringify(entries(second));
  }
  async function mutate(path, body) {
    const response = await fetch(`${route}cart/${path}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || 'Could not save your changes. Please try again.');
    return result;
  }
  async function refreshDrawer(state) {
    let html = state.sections?.['minicart-form'];
    if (!html) {
      const response = await fetch(`${location.pathname}?section_id=minicart-form`, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Changes saved, but the drawer could not refresh. Please reload the page.');
      html = await response.text();
    }
    const documentNode = new DOMParser().parseFromString(html, 'text/html');
    const source = documentNode.querySelector('#minicart-form');
    if (!source) throw new Error('Changes saved, but the drawer could not refresh. Please reload the page.');
    formRoot.innerHTML = source.innerHTML;
    cart.cartAction?.();
    window.BlsLazyloadImg?.init?.();
    const current = await getCart();
    document.querySelectorAll('.cart-count').forEach(element => {
      element.textContent = element.classList.contains('cart-count-drawer') ? `(${current.item_count})` : String(current.item_count);
    });
    document.querySelector('header-total-price')?.updateTotal?.(current);
    document.querySelector('free-ship-progress-bar')?.init?.(current.items_subtotal_price);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: current } }));
  }
  async function save(event) {
    event.preventDefault();
    if (!draft || saving) return;
    const variant = selectedVariant();
    if (!variant) { showError('This combination is unavailable. Choose another option.'); return; }
    const count = draft.countValues.indexOf(draft.count.value) + 1;
    const properties = { ...draft.item.properties };
    Object.keys(properties).forEach(key => { if (/^\d+\. name$/.test(key)) delete properties[key]; });
    for (let index = 0; index < count; index++) {
      const input = draft.names[index];
      const name = input.value.trim().toUpperCase();
      if (!name || /\p{Extended_Pictographic}/u.test(name)) {
        input.setCustomValidity('Enter a name using letters or numbers, without emojis.');
        input.reportValidity();
        showError('Enter every name using letters or numbers, without emojis.');
        return;
      }
      input.setCustomValidity('');
      properties[`${index + 1}. name`] = name;
    }
    properties.Font = draft.font.value;
    const current = await getCart().catch(() => null);
    if (!current || !current.items.some(line => line.key === draft.item.key)) {
      showError('Your cart changed while editing. Please reopen this item and try again.');
      return;
    }
    if (current.items.some(line => line.key !== draft.item.key && line.variant_id === variant.id && sameProperties(line.properties, properties))) {
      showError('This exact configuration is already in your cart. Choose different personalization.');
      return;
    }
    saving = true;
    const saveButton = form.querySelector('button[type="submit"]');
    saveButton.disabled = true;
    saveButton.textContent = 'Saving…';
    saveButton.setAttribute('aria-busy', 'true');
    showError('');
    let addedKey = null;
    try {
      let result;
      const sections = ['minicart-form'];
      if (variant.id === draft.item.variant_id) {
        result = await mutate('change', { id: draft.item.key, quantity: draft.item.quantity, properties, sections, sections_url: location.pathname });
      } else {
        const items = [{ id: variant.id, quantity: draft.item.quantity, properties }];
        if (draft.gift) {
          const matching = draft.gift.product.variants.find(giftVariant => giftVariant.option1.toLowerCase() === variant.options[0].toLowerCase() && giftVariant.available);
          if (!matching || draft.gift.product.id !== giftId) throw new Error('The matching included bracelet is unavailable for this finish. Your cart was not changed.');
          items.push({ id: matching.id, quantity: draft.gift.quantity, parent_id: variant.id });
        }
        await mutate('add', { items });
        const afterAdd = await getCart();
        const added = afterAdd.items.find(line => line.key !== draft.item.key && line.variant_id === variant.id && sameProperties(line.properties, properties));
        if (!added) throw new Error('Could not confirm the updated necklace. Your original item remains in the cart.');
        addedKey = added.key;
        if (draft.gift) {
          const section = await fetch(`${location.pathname}?section_id=minicart-form`).then(response => response.text());
          const parsed = new DOMParser().parseFromString(section, 'text/html');
          const newCard = [...parsed.querySelectorAll('.cart-item')].find(card => card.id === `minicart__product-${addedKey}`);
          if (!newCard?.querySelector('[data-maison-gift-variant]')) throw new Error('The matching bracelet was not confirmed as included. Your original item remains in the cart.');
        }
        // Shopify changes the parent's line key when another bundled chain is added.
        const original = afterAdd.items.find(line => line.variant_id === draft.item.variant_id &&
          sameProperties(line.properties, draft.item.properties));
        if (!original) throw new Error('Could not identify the original necklace. Your cart was not changed.');
        result = await mutate('change', { id: original.key, quantity: 0, sections, sections_url: location.pathname });
        addedKey = null;
      }
      await refreshDrawer(result);
      saving = false;
      close();
    } catch (error) {
      if (addedKey) {
        try { await mutate('change', { id: addedKey, quantity: 0 }); }
        catch (_) { error = new Error('The cart could not be restored automatically. Please reload the page and check its items before checkout.'); }
      }
      showError(error.message || 'Could not save your changes. Your draft is still here.');
    } finally {
      saving = false;
      saveButton.disabled = false;
      saveButton.textContent = 'Save changes';
      saveButton.removeAttribute('aria-busy');
    }
  }

  cart.addEventListener('click', event => {
    if (event.target.closest('[data-maison-upsell-close]') && upsellOverlay?.contains(event.target)) {
      event.preventDefault();
      closeUpsell();
      return;
    }
    const upsellButton = event.target.closest('[data-maison-cart-upsell-add]');
    if (upsellButton && root.contains(upsellButton)) {
      event.preventDefault();
      startUpsell(upsellButton);
      return;
    }
    const button = event.target.closest('[data-maison-cart-edit]');
    if (button && root.contains(button)) { event.preventDefault(); open(button); }
    else if (event.target.closest('[data-maison-editor-close]') && editor.contains(event.target)) {
      event.stopPropagation();
      close();
    }
  });
  form.addEventListener('submit', save);
  document.addEventListener('keydown', event => {
    if (upsellOverlay) {
      if (event.key === 'Escape') { event.preventDefault(); closeUpsell(); return; }
      if (event.key === 'Tab') {
        const focusable = [...upsellOverlay.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled)')];
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      return;
    }
    if (editor.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const focusable = [...editor.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled)')].filter(element => !element.closest('[hidden]'));
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.visualViewport?.addEventListener('resize', updateViewport);
  window.visualViewport?.addEventListener('scroll', updateViewport);
  new MutationObserver(() => {
    positionRemoveControls();
    syncDrawerCount();
  }).observe(formRoot, { childList: true });
  new MutationObserver(positionRemoveControls).observe(root, { attributes: true, attributeFilter: ['data-maison-ab-arm'] });
  positionRemoveControls();
})();
